import { useCallback } from 'react';
import LogRocket from 'logrocket';

import { useOrderDetailsSessionContext } from '../../modals/order-details-modal/event-tracking/order-details-session-context';
import { ORDER_DETAILS_ACTION, ADD_EDIT_SHIPMENT_ITEMS_ACTION } from '../../../constants/analytics-events';
import { Segment } from '../../../services/analytics-services/segment';

export const ADD_EDIT_SHIPMENT_ITEMS_ACTIONS = {
  OPEN: 'OPEN',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  CLOSE: 'CLOSE',
};

const logRocketAddEditItemsEventName = 'ADD_EDIT_SHIPMENT_ITEMS';

export const useTrackAddEditItemsShipmentAction = (action) => {
  const { sessionId } = useOrderDetailsSessionContext();

  return useCallback(
    (data) => {
      const { errors, fulfillmentPlanId, hasAdditionalItems, itemsToAdd, itemsToModify, itemsToDeactivate } = data || {};

      const trackEvent = () => {
        if (action === ADD_EDIT_SHIPMENT_ITEMS_ACTIONS.OPEN) {
          const environment = process.env.NODE_ENV || 'development';
          LogRocket.track(logRocketAddEditItemsEventName, {
            env: environment,
          });
        }
        Segment.trackEvent(ADD_EDIT_SHIPMENT_ITEMS_ACTION, {
          parentAction: ORDER_DETAILS_ACTION,
          action,
          sessionId,
          fulfillmentPlanId,
          errors,
          hasAdditionalItems,
          itemsToAdd,
          itemsToModify,
          itemsToDeactivate,
        });
      };
      setTimeout(trackEvent, 0);
    },
    [action, sessionId],
  );
};
